import { QaReportsViewModel } from "../../viewmodels/qaReports/QaReportsViewModel";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { classNames, withRouter } from "../../shared/utility";

import EmptyModal from "../../components/modals/EmptyModal";
import SimpleNotification from "../../components/SimpleNotification";
import DateRangeFilter from "../../components/filterDropdown/DateRangeFilter";
import SelectMenu from "../../components/controls/SelectMenu";
import QaReceivingOptions from "../../components/forms/qaReports/receiving/QaReceivingOptions";
import { useEffect } from "react";
import SalesByPluFilters from "../../components/forms/qaReports/salesByPlu/SalesByPluFilters";
import FlowReportsFilters from "../../components/forms/qaReports/flowReports/FlowReportsFilters";
import ProductionDetailsFilter from "../../components/forms/qaReports/productionDetails/ProductionDetailsFilter";
import ProductionSummaryFilter from "../../components/forms/qaReports/productionSummary/ProductionSummaryFilter";
import RecentReports from "../../components/forms/qaReports/RecentReports";

function QaReports(props) {
  const { logout } = props;
  const {
    emptyModal,
    loading,
    setEmptyModelOpen,
    setShowSimpleNotification,
    showSimpleNotification,
    filters,
    printSelectedReport,
    qaReportOptions,
    setFilters,
    reportType,
    setReportType,
    resetFilters,
    categories,
    products,
    suppliers,
    getCategoryTypes,
    getCustomersForDropdown,
    getProductOptionsForDropdown,
    getSupplierOptionsForDropdown,
    classes,
    getClassTypes,
    recentReports,
    recentReportsLoading,
    recentReportsError,
    getRecentReports,
    downloadReport,
    retryReport,
  } = QaReportsViewModel(logout);

  useEffect(() => {
    getCategoryTypes();
    getCustomersForDropdown();
    getProductOptionsForDropdown();
    getSupplierOptionsForDropdown();
    getClassTypes();
    getRecentReports();
  }, []);

  function renderReportTypeFields() {
    switch (reportType.value) {
      case 1:
        return (
          <div>
            <QaReceivingOptions
              filters={filters}
              setFilters={setFilters}
              categories={categories}
              products={products}
              suppliers={suppliers}
            />
          </div>
        );

      case 2:
        return (
          <div>
            <QaReceivingOptions
              filters={filters}
              setFilters={setFilters}
              categories={categories}
              products={products}
              suppliers={suppliers}
            />
          </div>
        );

      case 4:
        return (
          <div>
            <SalesByPluFilters
              filters={filters}
              setFilters={setFilters}
              products={products}
            />
          </div>
        );

      case 8:
        return (
          <div>
            <FlowReportsFilters
              filters={filters}
              setFilters={setFilters}
              products={products}
            />
          </div>
        );

      case 9:
          return (
            <div>
              <ProductionDetailsFilter
                filters={filters}
                setFilters={setFilters}
                products={products}
              />
            </div>
          );

      case 10:
        return (
          <div>
            <ProductionSummaryFilter
              filters={filters}
              setFilters={setFilters}
              products={products}
              classes={classes}
              categories={categories}
            />
          </div>
        );

      default:
        return <div></div>;
    }
  }

  return (
    <div>
      <SimpleNotification
        setShow={setShowSimpleNotification}
        showSimpleNotification={showSimpleNotification}
      />
      <div className="mt-2">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="sm:flex sm:items-center px-4 py-5 sm:px-4 card-custom">
            <div className="sm:flex-auto space-y-5">
              <h1 className="text-base font-semibold leading-6 text-gray-900">
                Generate reports
              </h1>
              <div className="grid grid-cols-6 gap-3">
                <div className="mt-2">
                  <SelectMenu
                    title="Report type"
                    handleInputChange={(e) => {
                      setReportType(e.target.value);
                      resetFilters();
                    }}
                    name="reportType"
                    options={qaReportOptions}
                    value={reportType}
                  />
                </div>
                <div
                  className={classNames(
                    reportType.value === 7 ? "hidden" : "col-span-2"
                  )}
                >
                  <DateRangeFilter
                    hideTitle={true}
                    startDate={filters.startDate}
                    endDate={filters.endDate}
                    onChange={(name, value) =>
                      setFilters({
                        ...filters,
                        [name]: value,
                      })
                    }
                    resetFilter={() =>
                      setFilters({
                        ...filters,
                        startDate: null,
                        endDate: null,
                      })
                    }
                    maxDate={new Date()}
                    showOneDate={reportType.value === 6}
                  />
                </div>
                <div
                  className={classNames(
                    "mt-auto flex w-full flex-col gap-2 sm:w-auto sm:flex-row",
                    reportType.value === 6 ? "lg:col-span-2" : ""
                  )}
                >
                  <button
                    className="w-full sm:w-auto rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    onClick={() => printSelectedReport("pdf")}
                    disabled={loading}
                  >
                    {loading ? "Generating…" : "Download"}
                  </button>
                  {reportType.value === 6 && (
                    <button
                      className="w-full sm:w-auto rounded-md border border-main-purple px-3 py-2 text-sm font-semibold main-purple shadow-sm hover:bg-indigo-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                      onClick={() => printSelectedReport("xlsx")}
                      disabled={loading}
                    >
                      {loading ? "Generating…" : "Download Excel"}
                    </button>
                  )}
                </div>
              </div>
              {renderReportTypeFields()}
            </div>
          </div>
        </div>
      </div>
      <RecentReports
        reports={recentReports}
        loading={recentReportsLoading}
        error={recentReportsError}
        onDownload={downloadReport}
        onRetry={retryReport}
      />
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QaReports));
